<script setup>
/**
 * DatePicker — global wrapper for vue2-datepicker.
 *
 * Forwards v-model and all props/attrs to the underlying library.
 * To migrate to Vue 3: swap the two import lines below for vue-datepicker-next.
 *
 * Usage:
 *   <DatePicker v-model="date" format="MM/DD/YYYY" />
 *   <DatePicker v-model="range" range />
 *   <DatePicker v-model="year" type="year" range />
 */
import DatePickerLib from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// Vue 3: swap the two lines above for:
// import DatePickerLib from 'vue-datepicker-next';
// import 'vue-datepicker-next/index.css';

import { getCurrentInstance } from 'vue';

defineProps({
    value: { default: null },
});

const instance = getCurrentInstance();
</script>

<template>
    <DatePickerLib
        v-bind="{ ...$attrs, value }"
        v-on="instance.proxy.$listeners"
    />
</template>
